import React from 'react';

function CommunityGuide() {
    const styles = {
        container: {
            // maxWidth: '800px',
            margin: '0 auto',
            padding: '20px',
            lineHeight: '1.6',
            color: '#333',
            overflowY: 'auto',
            height: '80vh', // Keeps the policy within a scrollable window
        },
        title: {
            // textAlign: 'center',
            fontSize: '20px',
            marginBottom: '20px',
        },
        paragraph: {
            fontSize: '14px',
            lineHeight: '1.6',
            margin: '10px 0',
        },
    };

    return (
        <div style={styles.container}>
            <h1 style={styles.title}>🐾 SOCIAL PAWS COMMUNITY GUIDELINES</h1>

            <p style={styles.paragraph}>
                A community built on trust, compassion, and dog-sharing joy
                Social Paws is a community of dog lovers — owners and non-owners alike — who believe that everyone deserves the opportunity to love a dog, and that every dog can enrich more than one home through thoughtful, responsible dog-sharing.
                This shared mission requires openness, communication, and collective care. These guidelines help keep our community safe, honest, and enjoyable for all.
            </p>

            <h1 style={styles.title}>💛 COMMUNITY VALUES</h1>
            <p style={styles.paragraph}>
                Dog Lovers Welcome — Including Non-Owners
            </p>
            <p style={styles.paragraph}>
                Whether you’re here to share your dog or care for a neighbor’s pup, there is a place for you at Social Paws. With transparency and trust, we can make dog-sharing possible in a way that benefits everyone.
            </p>
            <p style={styles.paragraph}>
                Appropriate Dog & Human Behavior
                Your dog’s profile is the place to share the truth — the good, the quirky, and the challenging.

            </p>

            <p style={styles.paragraph}>If your dog:</p>
            <p style={styles.paragraph}>isn’t friendly with other dogs</p>
            <p style={styles.paragraph}>prefers human-only interaction</p>
            <p style={styles.paragraph}>needs a close leash</p>
            <p style={styles.paragraph}>has behavioral or medical considerations</p>
            <p style={styles.paragraph}>please disclose it clearly. Transparency protects safety, builds trust, and connects you with dog pals who understand your dog’s needs and are happy to accommodate them.</p>
            <p style={styles.paragraph}>Interacting With Intention
                Social Paws is about real-life connections. Tossing treats, liking profiles, and messaging are just the beginning — the goal is to meet your neighbors for actual dog walks, where compatibility becomes clear.
                You’re encouraged to connect with as many neighbors as you’d like. Dog-sharing thrives when the community stays active, curious, and kind.</p>
            <p style={styles.paragraph}>Reviewing & Rating
                After real-life interactions, members can review and rate both dogs and humans.
                We encourage reviews because they:
                keep the community accountable
                support transparency
                build trust
                guide others toward safe and positive matches
            </p>
            <p style={styles.paragraph}>Thoughtful, respectful feedback strengthens Social Paws for everyone.</p>

            <h1 style={styles.title}>🚫 WE DO NOT TOLERATE</h1>
            <p style={styles.paragraph}>
                Dishonesty
                It may feel uncomfortable to list that your dog is reactive, nervous, or unfriendly with other dogs — but honesty is essential.
                Being truthful doesn’t make your dog a bad dog.
                It makes you a responsible member of the community.
                Honesty is the best pawlicy, and it ensures everyone gets the best, safest matches possible.
            </p>

            <p style={styles.paragraph}>
                Disrespecting Others’ Time
                Social Paws facilitates introductions, but you are responsible for showing up — fully and respectfully.
                We do not tolerate:
                no-shows
                last-minute cancellations without explanation
                leaving a neighbor waiting
                ghosting after making plans
            </p>

            <p style={styles.paragraph}>
                If you cannot make a scheduled walk: reschedule.
                If you’re running late: send a quick message.
                Respecting time shows respect for the dog, the human, and the spirit of our community.
            </p>

            <p style={styles.paragraph}>
                Animal Abuse
                Dog-sharing gives insight into how dogs are treated in everyday life. If you witness behavior that seems abusive, unsafe, or inappropriate, report it.
                Your identity will be protected, and we will take action.
                We prioritize the safety and wellbeing of both dogs and humans with zero exceptions.
            </p>

            <p style={styles.paragraph}>
                Not Picking Up After a Dog
                Whether it’s your dog or the one you’re caring for, you must pick up after them.
                If you forgot bags:
                ask a passerby
                improvise
                or return to the spot (and actually follow through)
                Leaving dog waste behind is disrespectful to your neighbors and the community environment.
            </p>

            <p style={styles.paragraph}>
                Pushing Other Agendas
                Social Paws is not a place to:
            </p>

            <p style={styles.paragraph}>
                sell products
                promote services
                recruit clients
                advertise unrelated causes
                redirect conversations to outside agendas
            </p>

            <p style={styles.paragraph}>
                Keep the space focused on what it was built for:
                Sharing dogs, building trust, and supporting community.
            </p>

            <h1 style={styles.title}>🌟 OUR COMMUNITY COMMITMENT</h1>
            <p style={styles.paragraph}>
                By using Social Paws, you agree to:
                communicate openly
                respect time and boundaries
                prioritize safety
                treat every dog and human with care
                contribute positively to the dog-sharing ecosystem
                Together, we can create a community where dogs have more love, humans have more connection,
                and neighborhoods feel a little more like home.
                Welcome to the pack.! 🐾💛
            </p>

        </div>
    );
}



export default CommunityGuide;
